import AudioCubeApiCallerInstance from '../../utils/AudioCubeApiCallerInstance';
import { SOUNDBOX_API_ENDPOINTS } from '../../URLConstants';

const multipartHeaders = {
    headers: {
        'Content-Type': 'multipart/form-data'
    }
};

export const GetBranchOffices = async (page = 1, limit = 10, where = {}) => {
    const response = await AudioCubeApiCallerInstance.get(
        SOUNDBOX_API_ENDPOINTS?.CREATE_BRANCH, {
        params: {
            where: JSON.stringify(where),
            page,
            limit
        }
    }
    );
    return response;
};

export const UpdateBranch = async (branchId, payload) => {
    const response = await AudioCubeApiCallerInstance.patch(SOUNDBOX_API_ENDPOINTS?.UPDATE_BRANCH(branchId), payload);
    return response;
}